var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',_vm._l((_vm.nav),function(link,index){return _c('nav-link-scroll',{key:_vm.getVForKey(index),attrs:{"id":link.id,"title":link.title},on:{"click":_vm.scroll}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }